import * as authenticators from './authenticators.js'
import * as utils from './utils.js'
import { AuthenticatorInfo, ClientInfo, RegistrationEncoded, RegistrationParsed, AuthenticationEncoded, AuthenticationParsed } from './types'
const utf8Decoder = new TextDecoder('utf-8')
/**
 * 解析客户端信息。
 * @param data 字符串或ArrayBuffer形式的数据。
 * @returns 返回解析后的客户端信息对象ClientInfo。
 */
export function parseClient(data :string|ArrayBuffer) :ClientInfo {
    if(typeof data == 'string')
        data = utils.parseBase64url(data) // 如果data是字符串，先进行base64url解码
    return JSON.parse(utf8Decoder.decode(data)) // 解码为JSON对象
}

/**
 * 解析身份验证器信息。
 * @param data 字符串或ArrayBuffer形式的数据。
 * @returns 返回解析后的身份验证器信息对象AuthenticatorInfo。
 */
export function parseAuthenticator(data :string|ArrayBuffer) :AuthenticatorInfo {
    if(typeof data == 'string')
        data = utils.parseBase64url(data) // 如果data是字符串，先进行base64url解码
    return authenticators.parseAuthBuffer(data) // 解析身份验证器数据
}

/**
 * 解析设备认证信息。
 * @param data 字符串或ArrayBuffer形式的数据。
 * @returns 返回解析后的设备认证信息。
 */
export function parseAttestation(data :string|ArrayBuffer) :unknown {
    // 使用原始数据值，该函数目前未进行实际解析操作
    return data;
}

/**
 * 解析注册信息。
 * @param registration 包含注册数据的对象。
 * @returns 返回解析后的注册信息对象RegistrationParsed。
 */
export function parseRegistration(registration :RegistrationEncoded) :RegistrationParsed {
    // 解析注册信息，包括用户名、凭证信息、客户端数据、身份验证器数据和设备认证数据
    return {
        username: registration.username,
        credential: registration.credential,

        client:        parseClient(registration.clientData),
        authenticator: parseAuthenticator(registration.authenticatorData),
        attestation:   registration.attestationData ? parseAttestation(registration.attestationData) : null
    }
}

/**
 * 解析认证信息。
 * @param authentication 包含认证数据的对象。
 * @returns 返回解析后的认证信息对象AuthenticationParsed。
 */
export function parseAuthentication(authentication :AuthenticationEncoded) :AuthenticationParsed {
    // 解析认证信息，包括凭证ID、客户端数据、身份验证器数据和签名
    return {
        credentialId:  authentication.credentialId,
        client:        parseClient(authentication.clientData),
        authenticator: parseAuthenticator(authentication.authenticatorData),
        signature: authentication.signature
    }
}
